import React, { CSSProperties } from "react";
import styles from "./roles-description-popover.module.scss";
import { GradientBorderContainer } from "@src/components/templates/layouts/gradient-border-container/gradient-border-container";
import { RolesDescriptions } from "@src/types/role-manager";
import { useI18N } from "@src/language/language-context";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
const cssClassName = "roles-description-popover";

interface RolesDescriptionPopoverProps {
  rolesDescriptions: RolesDescriptions;
  customTopPositioning?: number;
}

export const RolesDescriptionPopover = ({
  rolesDescriptions,
  customTopPositioning = 40,
}: RolesDescriptionPopoverProps) => {
  const i18n = useI18N();

  const texts = {
    rolesDescriptionTitle: i18n(
      "modules.rolesDescriptionsPopover.rolesDescriptionsTitle",
    ),
  };

  return (
    <div
      className={styles[`${cssClassName}`]}
      style={
        {
          "--popover-top": `${customTopPositioning}px`,
        } as CSSProperties
      }
    >
      <GradientBorderContainer>
        <div className={styles[`${cssClassName}__popover`]}>
          <div className={styles[`${cssClassName}__popover-title-container`]}>
            <SubTitle text={texts.rolesDescriptionTitle} />
          </div>
          <FlexColumnContainer verticalGap={8}>
            {Object.entries(rolesDescriptions).map(([roleName, role]) => (
              <div
                key={roleName}
                className={styles[`${cssClassName}__popover-content`]}
              >
                <p className={styles[`${cssClassName}__role-name`]}>
                  {roleName}
                </p>
                <p className={styles[`${cssClassName}__role-description`]}>
                  {role.description}
                </p>
              </div>
            ))}
          </FlexColumnContainer>
        </div>
      </GradientBorderContainer>
    </div>
  );
};
